import React, { useContext, useEffect, useState } from "react";

import { useAuth0 } from "@auth0/auth0-react";
import Box from "@mui/material/Box";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import CrossSvg from "assets/icons/svg/cross";
import MyButton from "components/MyButton";
import { useFormik, useFormikContext } from "formik";
import fs from 'fs';
import FormData from 'form-data';
import { FormikWizard } from "formik-wizard-form";
import { useDisableEnterKey } from "hook/useDisableEnterKey";
import moment from "moment";
import { toastr } from "react-redux-toastr";
import { useHistory } from 'react-router-dom';
import { DateFormetContext } from "../../../app/App.js";
import FinanceService from "../../../Lib/API/Finance";
import UserContext from "../NewChargeContext";
import { CheckFloatValue, isObjectEmpty } from "./../../../utils/functions";
import { validateObject } from "./../../../utils/validateObject";
import AccountsSelection from "./AccountsSelection";
import BatchChargeDetails from "./BatchChargeDetails";
import Account from "./BatchChargeType/Account";
import PreviousAmount from "./BatchChargeType/PreviousAmount";
import Review from "./Review";

const NewBatchBillinCharge = ({
  setStepOne,
  activeIndex,
  handleClose,
  closeModal,
  data,
  handleClick,
  ...props
}) => {
  const history = useHistory()

  const dateFormet = React.useContext(DateFormetContext);
  const [/* finalValues */ setFinalValues] = useState({});
  const [finished, setFinished] = useState(false);
  // const { hfinish, setHFinish } = useContext(BatchContext);
  const [title, setTitle] = useState("New Bulk Charge");
  const [transactionIds, setTransactionIds] = useState([]);
  const [chargeId, setChargeId] = useState("");
  const { getAccessTokenSilently } = useAuth0();
  const [BatchType, setBatchType] = useState("");
  const [errors, setErrors] = useState({});
  const { editData } = useContext(UserContext);
  const [batchSubmit, setBatchSubmit] = useState(false);
  const [loading, setLoading] = useState(false);

  useDisableEnterKey(true);


  const formik = useFormik({
    isInitialValid: false,
    enableReinitialize: true,
    initialValues: {},
    validationSchema: "",
    onSubmit: async (values) => { },
  });
  const batchTitle = "New Bulk Charge";
  const initialValues = editData.hasOwnProperty("_id")
    ? {
      account_type: editData?.account_type ?? "",
      batch_name: editData?.batch_name ?? "",
      batch_type: editData?.batch_type,
      batch_charge_type: editData?.batch_charge_type ?? "",
      charge_desc: editData?.charge_desc ?? "",
      batch_amount: editData?.batch_amount ?? "",
      charge_date: editData?.charge_date ?? "",
      due_date: editData?.due_date ?? "",
      description: editData?.description ?? "",
      amount: editData?.amount ?? 0,
      SubLedger: {
        id: editData?.SubLedger?.id ?? "",
        name: editData?.SubLedger?.name ?? "",
      },
      Ledger: {
        id: editData?.Ledger?.id ?? "",
        name: editData?.Ledger?.name ?? "",
      },
      "is_splitted": editData?.is_splitted ?? false,
      "split_duration": editData?.split_duration,
      "number_of_split": editData?.number_of_split,
      "tax_type": editData?.tax_type,
      "tax": editData?.tax_deductible,
      "comment_checkbox": editData?.comment_invoice?.visible ?? false,
      "note": editData?.comment_invoice?.note ?? ".",
      "comment_receipt": editData?.comment_receipt?.visible ?? false,
      "receipt_note": editData?.comment_receipt?.note ?? ".",
      "discount": {
        "type": editData?.discount?.type,
        "value": editData?.discount?.value,
      },
      category_type: { id: "", name: "" },
      search: "",
      billing_type: editData?.billing_type ?? [],
      discount_type: editData?.discount?.type ?? "%",
      discount: editData?.discount?.value ?? "",
      date_type: editData?.filter?.date_range?.date_type ?? "",
      [editData?.filter?.date_range?.dateFrom ? "start_date" : ""]:
        new Date(editData?.filter?.date_range?.dateFrom) ?? "",
      [editData?.filter?.date_range?.dateFrom ? "end_date" : ""]:
        new Date(editData?.filter?.date_range?.dateTo) ?? "",
      status: editData?.filter?.status ?? "",
      amount_previous:
        formik?.values?.amount_previous_type === "discount"
          ? editData?.discount?.value
          : editData?.add_amount?.value,
      amount_type:
        formik?.values?.amount_previous_type === "discount"
          ? editData?.discount?.type
          : editData?.add_amount?.type,
      amount_previous_type: editData?.discount ? "discount" : "add_amount",
      amount_range: {
        amountFrom: editData?.filter?.amount_range?.amountFrom ?? 0,
        amountTo: editData?.filter?.amount_range?.amountTo ?? 0,
      },
      values: [
        {
          account_type: editData?.account_type ?? "",
          batch_name: editData?.batch_name ?? "",
          batch_charge_type: editData?.batch_charge_type ?? "",
          charge_desc: editData?.charge_desc ?? "",
          batch_amount: editData?.batch_amount ?? "",
          charge_date: editData?.charge_date ?? "",
          due_date: editData?.due_date ?? "",
          SubLedger: {
            id: "",
            name: "",
          },
          Ledger: {
            id: "",
            name: "",
          },
          search: "",

          category_type: { id: "", name: "" },
          billing_type: [],
          charges_file: ""

        },
      ],
      actual_total: data.total_amount,
      current_amount: data.total_amount,
      account_name: data.Account,
      isTransactionSave: true,
      isEdit: true,
      id: editData?._id,
      checks: [],
      isInstallmentTransaction: editData?.isInstallmentTransaction,
      installmentDetailsTransaction: editData?.isInstallmentTransaction ? {
        cycle: editData?.installmentDetailsTransaction?.numberOfInstallment || null,
        startInstallment: editData?.installmentDetailsTransaction?.lastInstallmentDate || null,
      } : null,
    }
    : {
      is_draft: "false",
      batch_name: "",
      description: "",
      charge_desc: "",
      Ledger: {},
      SubLedger: {},
      batch_type: "manual",
      accounts_with_amount: [],
      // accounts: [],
      charge_date: moment(new Date()).utcOffset("+0100").format("YYYY-MM-DD"),
      batchSubmit: batchSubmit,
      // date_range: moment(new Date()).utcOffset('+0100').format("YYYY-MM-DD"),
      due_date: moment(new Date()).utcOffset("+0100").format("YYYY-MM-DD"),
      amount: 0,
      discount_type: "%",
      discount: "",
      status: "all",
      subtotal_amount: "",
      billing_type: [],
      previous_amount: "",
      amount_type: "%",
      amount_previous_type: "add_amount",
      total_previous_amount: "",
      amount_range: {
        amountFrom: 0,
        amountTo: 0,
      },
      date_range: {},
      amount_for_accounts: "",
      nextpayment: false,
      "is_splitted": false,
      "split_duration": "",
      "number_of_split": "",
      "tax_type": "%",
      "tax": "",
      "comment_checkbox": false,
      "note": "",
      "comment_receipt": false,
      "receipt_note": "",
      "discount": {
        "type": "%",
        "value": "",
      },
      isInstallmentTransaction: false,
      installmentDetailsTransaction: null,
    };
  /**
   *
   * @param {Record<any, any>} values
   * @param {() => void} handleNext
   */
  useEffect(() => {
    if (data) {
      if (data?._id) setTransactionIds([data._id]);
      setChargeId(data?.charge?._id);
    }
  }, [data]);

  const onStepClick = (values, handleNext, setFieldValue, currentStep) => {
    const {
      batch_name,
      batch_type,
      // SubLedger,
      Ledger,
      amount,
      discount,
      charge_date,
      due_date,
      accounts,
      billing_type,
      status,
      amount_range,
      amount_previous,
      amount_type,
      date_range,
      start_date,
      end_date,
      accountTags,
      contactTags,
      charges_file
    } = values;

    let [validationObj, validationKeys] = [{}, []];

    if (currentStep === 0) {
      switch (batch_type) {
        case "manual":
          // !! object with kye value pair
          validationObj = {
            batch_name,
            Ledger,
            // Ledger,
            // SubLedger,
            amount,
            // charge_date,
          };
          // !! only key names from object that are required
          // !! if this is empty or undefined all the values from validationObj will be required
          validationKeys = [
            "batch_name",
            "description",
            "Ledger",
            // "SubLedger",
            "amount",
            // "charge_date",
          ];
          break;
        case "account":
          validationObj = {
            batch_name,
            Ledger,
            // SubLedger,
            billing_type,
            // charge_date,
            // due_date,
          };
          break;
        case "previous_amount":
          validationObj = {
            batch_name,
            status,
            Ledger,
            // SubLedger,
            amount_range,
            // charge_date,
            // due_date,
          };
          break;
        case "file":
          validationObj = {
            batch_name,
            charges_file,
            // Ledger
            // status,
            // Ledger,
            // SubLedger,
            // amount_range,
            // charge_date,
            // due_date,
          };
          break;
        default:
          break;
      }
    }
    if (currentStep === 1) {
      validationObj = { accounts };
    }
    const { hasErrors, errors: validationErrors } = validateObject(
      validationObj,
      validationKeys
    );

    if (values.date_type === "" && values.batch_type === "previous_amount") {
      return toastr.info("Please select date_range and date type")
    }

    if (values.Ledger.id === "") {
      return toastr.info("Please select ledger")
    }

    // if (values.charge_date === "" || values.charge_date === null) {
    //   return toastr.info("please select charge date.")
    // }

    if (values.amount_range.amountFrom === "" && values.batch_type === "previous_amount") {
      return toastr.info("Validation", "Please add amount range")
    }

    if (values.amount_range.amountTo === "" && values.batch_type === "previous_amount") {
      return toastr.info("Validation", "Please add amount range")
    }

    if (parseInt(values.amount_range.amountTo) < parseInt(values.amount_range.amountFrom) && values.batch_type === "previous_amount") {
      return toastr.info("Validation", "Amount range to should be greater than Amount range from ")
    }

    if (values.require_notes === true && values.note === "") {
      return toastr.info("Validation", "Please add some notes")
    }

    if (values.charge_date === "" || values.charge_date === null) {
      return toastr.info("Validation", "please select charge date.")
    }

    if (values?.is_splitted && (values?.number_of_split === 0 || values?.number_of_split === "")) {
      return toastr.info("Validation", "Number of split should be greater than zero!")
    }


    if (values.amount < values.discount && values.discount_type === "$" && values.batch_type === "manual") {
      return toastr.info("Validation", "Amount should be greater than the discount value")
    }

    if (values?.isInstallmentTransaction && !values?.installmentDetailsTransaction?.cycle) {
      return toastr.info("Validation", "Please select number of installments")
    }

    if (hasErrors) {
      setErrors(validationErrors);
      // window.scrollTo(0, 0);
    } else {
      if (values.due_date === "" || values.due_date === null) {
        toastr.info("Validation", "Please select due date.")
      }
      else {
        setErrors({});
        handleNext();
      }
    }
  };

  const delay = ms => new Promise(resolve => setTimeout(() => resolve(), ms));

  const uploadFile = async (values) => {
    console.log("values ===", values);
    // let fileData = new FormData();
    // let fileData = {
    //   batch_name: values?.batch_name,
    //   transactions: values?.charges_file
    // }
    if (!values?.batch_name) return toastr.info("Batch name is empty");
    if (!values?.charges_file) return toastr.info("Please upload charges file");

    const formData = new FormData();
    formData.append('batch_name', values?.batch_name);
    formData.append('transactions', values?.charges_file);
    if (values?.description)
      formData.append('description', values?.description);
    // formData.append('batch_type', "file");


    if (values?.SubLedger?.id) {
      formData.append('SubLedger', JSON.stringify({
        id: values.SubLedger.id,
        name: values.SubLedger.name,
      }));
    }

    if (values?.Ledger?.id) {
      formData.append('Ledger', JSON.stringify({
        id: values.Ledger.id,
        name: values.Ledger.name,
      }));
    }






    // fileData.append('batch_name', values?.batch_name);
    // fileData.append('transactions', values?.charges_file);
    // data.append('test', 'test')
    // const stream = fs.createReadStream(values?.charges_file);
    // let fileData =
    //   values?.SubLedger?.id
    //     ? {
    //       batch_name: values?.batch_name,
    //       description:
    //         values?.description ? values?.description : undefined,
    //       Ledger: {
    //         id: values?.Ledger?.id,
    //         name: values?.Ledger?.name,
    //       },
    //       SubLedger: {
    //         id: values?.SubLedger?.id,
    //         name: values?.SubLedger?.name,
    //       },
    //       batch_type: "file",
    //       transactions: stream,
    //     }
    //     : values?.Ledger?.id ? {
    //       batch_name: values?.batch_name,
    //       description:
    //         values?.description ? values?.description : undefined,
    //       Ledger: {
    //         id: values?.Ledger?.id,
    //         name: values?.Ledger?.name,
    //       },
    //       // SubLedger: {
    //       //   id: values?.SubLedger?.id,
    //       //   name: values?.SubLedger?.name,
    //       // },
    //       batch_type: "file",
    //       transactions: stream,
    //     } : {
    //       batch_name: values?.batch_name,
    //       description:
    //         values?.description ? values?.description : undefined,
    //       // Ledger: {
    //       //   id: values?.Ledger?.id,
    //       //   name: values?.Ledger?.name,
    //       // },
    //       // SubLedger: {
    //       //   id: values?.SubLedger?.id,
    //       //   name: values?.SubLedger?.name,
    //       // },
    //       batch_type: "file",
    //       transactions: stream
    //     }

    //   ;
    // for (let [key, value] of data.entries()) {
    //   console.log(`${key}:`, value);
    // }
    console.log("fileData", formData);
    // return;

    setLoading(true);


    const token = await getAccessTokenSilently();

    await FinanceService.addBatchPaymentFile(

      // is_draft: !!saveAsDraft,
      formData
      ,
      token
    )
      .then((res) => {
        toastr.success("Success", "Transaction Saved Successfully");
        handleClose();
        // history.push('/finance/batch');
        // setTimeout(() => {
        window.location.reload();
        // }, 1000);
        // setFieldValue("isTransactionSave", true);
        window.dispatchEvent(new CustomEvent("refresh"));
        // formik.setFieldValue("amount_range?.amountFrom", "");
        // formik.setFieldValue("amount_range?.amountTo", "");
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      });
    setLoading(false);



  }
  const saveTransaction = async (values, saveAsDraft) => {

    // return;
    if (values?.is_splitted && (values?.number_of_split === 0 || values?.number_of_split === "")) {
      return toastr.info("validation", "Number of split should be greater than zero!")
    }

    if (values.amount < values.discount && values.discount_type === "$" && values.batch_type === "manual") {
      return toastr.info("Validation", "Amount should be greater than the discount value")
    }

    if (values?.isInstallmentTransaction && !values?.installmentDetailsTransaction?.cycle) {
      return toastr.info("Validation", "Please select number of installments")
    }

    setLoading(true);
    await delay(2000);
    let manualData = {
      batch_name: values?.batch_name,
      Ledger: {
        id: values?.Ledger?.id,
        name: values?.Ledger?.name,
      },
      description:
        values?.description ? values?.description : undefined,
      // SubLedger: {
      //   id: values?.SubLedger?.id,
      //   name: values?.SubLedger?.name,
      // },
      batch_type: values?.batch_type,
      accounts: values?.accounts?.map(account => ({ id: account?.id, name: account?.name })),
      charge_date: values?.charge_date,
      amount: values?.amount ?? 0,
      due_date: values?.due_date,
      "is_splitted": values?.is_splitted ?? false,
      "tax_type": values?.tax_type,
      "tax_deductible": values?.tax === "" ? 0 : values?.tax,
      "comment_invoice": {
        "visible": values?.comment_checkbox ?? false,
        "note": values?.note === "" ? "." : values?.note
      },
      "comment_receipt": {
        "visible": values?.comment_receipt ?? false,
        "note": values?.receipt_note === "" ? "." : values?.receipt_note
      },
      "discount": {
        "type": values?.discount_type,
        "value": values?.discount === "" ? 0 : values?.discount
      },
    };

    if (!!values?.is_splitted) {
      manualData = {
        ...manualData,
        "split_duration": values?.split_duration,
        "number_of_split": values?.number_of_split === "" ? 0 : values?.number_of_split,
      }
    }

    if (values?.isInstallmentTransaction) {
      manualData = {
        ...manualData,
        isInstallmentTransaction: values?.isInstallmentTransaction,
        installmentDetailsTransaction: {
          numberOfInstallment: values?.installmentDetailsTransaction?.cycle,
          lastInstallmentDate: values?.installmentDetailsTransaction?.startInstallment,
        }
      }
    }



    let accountData =
      values?.discount && values?.SubLedger?.id
        ? {
          batch_name: values?.batch_name,
          description:
            values?.description ? values?.description : undefined,
          Ledger: {
            id: values?.Ledger?.id,
            name: values?.Ledger?.name,
          },
          SubLedger: {
            id: values?.SubLedger?.id,
            name: values?.SubLedger?.name,
          },
          billing_type: values?.billing_type,
          // billing_type: {
          //   id: values?.billing_type?.id,
          //   name: values?.billing_type?.name,
          // },

          batch_type: values?.batch_type,
          // accounts: values?.accounts,
          accounts: values?.accounts?.map(account => ({ id: account?.id, name: account?.name })),
          discount: {
            type: values?.discount_type ?? "%",
            value: values?.discount !== "" ? values?.discount : 0,
          },
          charge_date: values?.charge_date,
          amount: values?.amount ?? values?.amount_for_accounts,
          due_date: values?.due_date,
          "is_splitted": values?.is_splitted ?? false,
          "tax_type": values?.tax_type,
          "tax_deductible": values?.tax === "" ? 0 : values?.tax,
          "comment_invoice": {
            "visible": values?.comment_checkbox ?? false,
            "note": values?.note === "" ? "." : values?.note
          },
          "comment_receipt": {
            "visible": values?.comment_receipt ?? false,
            "note": values?.receipt_note === "" ? "." : values?.receipt_note
          },
          "split_duration": values?.split_duration,
          "number_of_split": values?.number_of_split === "" ? 0 : values?.number_of_split,
        }
        : values?.accounts?.length > 0
          ? {
            batch_name: values?.batch_name,
            description:
              values?.description ? values?.description : undefined,
            Ledger: {
              id: values?.Ledger?.id,
              name: values?.Ledger?.name,
            },
            billing_type: values?.billing_type,
            discount: {
              type: values?.discount_type ?? "%",
              value: values?.discount !== "" ? values?.discount : 0,
            },
            batch_type: values?.batch_type,
            // accounts: values?.accounts,
            accounts: values?.accounts?.map(account => ({ id: account?.id, name: account?.name })),
            charge_date: values?.charge_date,
            amount: values?.amount ?? values?.amount_for_accounts,
            due_date: values?.due_date,
            "is_splitted": values?.is_splitted ?? false,
            "tax_type": values?.tax_type,
            "tax_deductible": values?.tax === "" ? 0 : values?.tax,
            "comment_invoice": {
              "visible": values?.comment_checkbox ?? false,
              "note": values?.note === "" ? "." : values?.note
            },
            "comment_receipt": {
              "visible": values?.comment_receipt ?? false,
              "note": values?.receipt_note === "" ? "." : values?.receipt_note
            },
            "split_duration": values?.split_duration,
            "number_of_split": values?.number_of_split === "" ? 0 : values?.number_of_split,
          }
          : {
            batch_name: values?.batch_name,
            description:
              values?.description ? values?.description : undefined,
            Ledger: {
              id: values?.Ledger?.id,
              name: values?.Ledger?.name,
            },
            billing_type: values?.billing_type,
            batch_type: values?.batch_type,
            // accounts: values?.accounts,
            accounts: values?.accounts?.map(account => ({ id: account?.id, name: account?.name })),
            discount: {
              type: values?.discount_type ?? "%",
              value: values?.discount !== "" ? values?.discount : 0,
            },
            charge_date: values?.charge_date,
            amount: values?.amount ?? values?.amount_for_accounts,
            due_date: values?.due_date,
            "is_splitted": values?.is_splitted ?? false,
            "tax_type": values?.tax_type,
            "tax_deductible": values?.tax === "" ? 0 : values?.tax,
            "comment_invoice": {
              "visible": values?.comment_checkbox ?? false,
              "note": values?.note === "" ? "." : values?.note
            },
            "comment_receipt": {
              "visible": values?.comment_receipt ?? false,
              "note": values?.receipt_note === "" ? "." : values?.receipt_note
            },
            "split_duration": values?.split_duration,
            "number_of_split": values?.number_of_split === "" ? 0 : values?.number_of_split,
          };

    // if (values?.description !== "") {
    //   accountData = {
    //     ...accountData,
    //     description: values?.description,
    //   }
    // }

    if (values?.isInstallmentTransaction) {
      accountData = {
        ...accountData,
        isInstallmentTransaction: values?.isInstallmentTransaction,
        installmentDetailsTransaction: {
          numberOfInstallment: values?.installmentDetailsTransaction?.cycle,
          lastInstallmentDate: values?.installmentDetailsTransaction?.startInstallment,
        }
      }
    }

    let previousData =
      values?.amount_previous && values?.SubLedger?.id
        ? {
          batch_name: values?.batch_name,
          description:
            values?.description ? values?.description : undefined,
          Ledger: {
            id: values?.Ledger?.id,
            name: values?.Ledger?.name,
          },
          SubLedger: {
            id: values?.SubLedger?.id,
            name: values?.SubLedger?.name,
          },
          batch_type:
            values?.batch_type === "previous_amount"
              ? "previous_amounts"
              : "",
          accounts: values?.accounts,
          "is_splitted": values?.is_splitted ?? false,
          "tax_type": values?.tax_type,
          "tax_deductible": values?.tax === "" ? 0 : values?.tax,
          "comment_invoice": {
            "visible": values?.comment_checkbox ?? false,
            "note": values?.note === "" ? "." : values?.note
          },
          "comment_receipt": {
            "visible": values?.comment_receipt ?? false,
            "note": values?.receipt_note === "" ? "." : values?.receipt_note
          },
          "discount": {
            "type": values?.discount_type,
            "value": values?.discount === "" ? 0 : values?.discount
          },
          "split_duration": values?.split_duration,
          "number_of_split": values?.number_of_split === "" ? 0 : values?.number_of_split,
          // accounts: values?.accounts?.map(account => ({ id: account?.id, name: account?.name })),
          discount: {
            type: values?.discount_type ?? "%",
            value: values?.discount !== "" ? values?.discount : 0,
          },
          charge_date: values?.charge_date,
          due_date: values?.due_date,
          amount:
            isNaN(values?.total_previous_amount) ? 0 : CheckFloatValue(parseFloat(values?.total_previous_amount)),
          filter: {
            date_range: {
              date_type: values?.date_type ?? "charge_date",
              dateFrom: values?.start_date ?? "",
              dateTo: values?.end_date ?? "",
            },
            amount_range: {
              amountFrom: values?.amount_range?.amountFrom ?? 0,
              amountTo: values?.amount_range?.amountTo ?? 0,
            },
            status: values?.status,
          },
          [values?.amount_previous_type]: {
            type: values?.amount_type ?? "$",
            value:
              values?.amount_previous
                ? values?.amount_previous : "0",
          },
        }
        : {
          batch_name: values?.batch_name,
          description:
            values?.description ? values?.description : undefined,
          Ledger: {
            id: values?.Ledger?.id,
            name: values?.Ledger?.name,
          },

          filter: {
            date_range: {
              date_type: values?.date_type ?? "charge_date",
              dateFrom: values?.start_date ?? "",
              dateTo: values?.end_date ?? "",
            },
            amount_range: {
              amountFrom: values?.amount_range?.amountFrom ?? 0,
              amountTo: values?.amount_range?.amountTo ?? 0,
            },
            status: values?.status,
          },
          batch_type:
            values?.batch_type === "previous_amount"
              ? "previous_amounts"
              : "",
          accounts: values?.accounts,
          "is_splitted": values?.is_splitted ?? false,
          "tax_type": values?.tax_type,
          "tax_deductible": values?.tax === "" ? 0 : values?.tax,
          "comment_invoice": {
            "visible": values?.comment_checkbox ?? false,
            "note": values?.note === "" ? "." : values?.note
          },
          "comment_receipt": {
            "visible": values?.comment_receipt ?? false,
            "note": values?.receipt_note === "" ? "." : values?.receipt_note
          },
          "discount": {
            "type": values?.discount_type,
            "value": values?.discount === "" ? 0 : values?.discount
          },
          "split_duration": values?.split_duration,
          "number_of_split": values?.number_of_split === "" ? 0 : values?.number_of_split,
          // accounts: values?.accounts?.map(account => ({ id: account?.id, name: account?.name })),
          discount: {
            type: values?.discount_type ?? "%",
            value: values?.discount !== "" ? values?.discount : 0,
          },
          charge_date: values?.charge_date ?? "",
          due_date: values?.due_date ?? "",
          amount:
            isNaN(values?.total_previous_amount) ? 0 : CheckFloatValue(parseFloat(values?.total_previous_amount)),
          [values?.amount_previous_type]: {
            type: values?.amount_type ?? "$",
            value:
              values?.amount_previous
                ? values?.amount_previous : "0",
          },
        };

    // if (values?.description !== "") {
    //   previousData = {
    //     ...previousData,
    //     description: values?.description,
    //   }
    // }
    if (values?.isInstallmentTransaction) {
      previousData = {
        ...previousData,
        isInstallmentTransaction: values?.isInstallmentTransaction,
        installmentDetailsTransaction: {
          numberOfInstallment: values?.installmentDetailsTransaction?.cycle,
          lastInstallmentDate: values?.installmentDetailsTransaction?.startInstallment,
        }
      }
    }
    if (values?.SubLedger?.id) {
      manualData = {
        ...manualData,
        SubLedger: {
          id: values?.SubLedger?.id,
          name: values?.SubLedger?.name,
        },
      }

      accountData = {
        ...accountData,
        SubLedger: {
          id: values?.SubLedger?.id,
          name: values?.SubLedger?.name,
        },
      }

      previousData = {
        ...previousData,
        SubLedger: {
          id: values?.SubLedger?.id,
          name: values?.SubLedger?.name,
        },
      }

    }


    const token = await getAccessTokenSilently();
    // let selectedData = { ...manualData };
    // console.log(selectedData, !selectedData?.data?.SubLedger?.id, "selectedData?.data?.SubLedger?.id", selectedData?.data?.SubLedger?.id)
    // if (!selectedData?.data?.SubLedger?.id) {
    //   delete selectedData?.data?.SubLedger;
    // }


    if (editData?._id) {
      setLoading(true);
      await FinanceService.editBatchPayment(
        editData?._id,
        {
          is_draft: !!saveAsDraft,

          data:
            values?.batch_type === "manual"
              ? { ...manualData }
              : values?.batch_type === "previous_amount"
                ? { ...previousData }
                : { ...accountData },
        },
        token
      )
        .then((res) => {
          setBatchSubmit(false);
          toastr.success("Success", "Transaction Saved Successfully");
          handleClose();
          window.location.reload();
          // setFieldValue("isTransactionSave", true);
          window.dispatchEvent(new CustomEvent("refresh"));
        })
        .catch((err) => {
          setBatchSubmit(false);
          toastr.error("Error", err?.data?.message || "Please fill all required fields");
        });
      setLoading(false);
    }
    else {
      setLoading(true);
      await FinanceService.addBatchPayment(
        {
          is_draft: !!saveAsDraft,
          data:
            values?.batch_type === "manual"
              ? { ...manualData }
              : values?.batch_type === "previous_amount"
                ? { ...previousData }
                : { ...accountData },
        },
        token
      )
        .then((res) => {
          toastr.success("Success", "Transaction Saved Successfully");
          handleClose();
          // history.push('/finance/batch');
          // setTimeout(() => {
          window.location.reload();
          // }, 1000);
          // setFieldValue("isTransactionSave", true);
          window.dispatchEvent(new CustomEvent("refresh"));
          // formik.setFieldValue("amount_range?.amountFrom", "");
          // formik.setFieldValue("amount_range?.amountTo", "");
        })
        .catch((err) => {
          toastr.error("Error", err?.data?.message || "Something went wrong");
        });
      setLoading(false);
    }
  };
  const onModalClose = () => {
    closeModal();
  };

  // console.log("STATUS:: currentStepIndex",currentStepIndex)

  return (
    <>
      <div className=" text-right pr-0 pt-0">
        <span className="cursor-pointer" onClick={onModalClose}>
          <CrossSvg />

        </span>
      </div>
      <div className="new-charge">
        <div className="new-batch-charge-header">{batchTitle}</div>
        {!isObjectEmpty(errors)
          ? Object.values(errors).map((item) => toastr.info("Validation", item))
          : null}
        <FormikWizard
          initialValues={{
            ...initialValues,
          }}
          onSubmit={(values) => {
            setFinalValues(values);
            handleClose();
          }}
          validate={(values) => {
            const errors = {};
            if (!values.batch_name) {
              errors.batch_name = "Required";
            } else if (!values?.batch_name?.match(/^(?![\s-])[\w\s-]+$/)) {
              errors.batch_name = "Enter a valid name";
            }
            if (Object.keys(values.Ledger).length === 0) {
              errors.Ledger = "Required";
            }
            // if (Object.keys(values.SubLedger).length === 0) {
            //   errors.SubLedger = "Required";
            // }
            // if (!values.amount) {
            //   errors.amount = "Required";
            // }
            return errors;
          }}
          validateOnNext
          activeStepIndex={activeIndex}
          steps={[
            {
              component: BatchChargeDetails,
            },
            {
              component: AccountsSelection,
            },
            {
              component: Review,
            },
          ]}
        >
          {({
            currentStepIndex,
            renderComponent,
            handlePrev,
            handleNext,
            isNextDisabled,
            isPrevDisabled,
            values,
            setFieldValue,
          }) => {
            return (
              <form onSubmit={formik.handleSubmit}>
                <div className="batch-charge-content charge-content" >
                  <div className="test charge-content-header py-15">
                    <div className="fom-steps-batch fom-steps batch-billing-stepper" style={{
                      position: "relative",
                      left: "54%",
                    }}>
                      <Stepper activeStep={currentStepIndex}>
                        <Step
                          completed={currentStepIndex > 0}
                          className="step pl-0"
                        >
                          <StepLabel className="step-label">
                            Charges Details
                          </StepLabel>
                        </Step>
                        <Step completed={currentStepIndex > 1}>
                          <StepLabel>Accounts Selection</StepLabel>
                        </Step>
                        <Step
                        // completed={hfinish}
                        >
                          <StepLabel>Review</StepLabel>
                        </Step>
                      </Stepper>
                    </div>
                  </div>
                  <div className="">
                    {currentStepIndex !== 0 && currentStepIndex == 0
                      ? setTitle("New Bulk Charge")
                      : setTitle("New Bulk Charge")}
                    <div className="form-content render-background">
                      <Box my="2rem" className="w-100 mb-0">
                        {renderComponent()}
                      </Box>
                      <div className="form-content-bottom">
                        {/* {currentStepIndex !== 0 && <hr />} */}
                        <div className="form-footer mt-30 footer-buttons-alignment">
                          {currentStepIndex !== 0 ? (
                            <MyButton
                              type="secondary"
                              content={
                                <span>
                                  <span className="mr-2"> {"<"}</span>
                                  <span>
                                    {currentStepIndex === 1
                                      ? "Charge Details"
                                      : "Account Selection"}
                                  </span>
                                </span>
                              }
                              onClick={() => {
                                if (currentStepIndex - 1 === 0) setStepOne(true);
                                setFieldValue("nextpayment", true);

                                // setHFinish(false);
                                handlePrev();
                              }}
                              disabled={isPrevDisabled}
                            />
                          ) : (
                            <br />
                          )}
                          <div className="d-flex align-items-center">
                            {values?.batch_type !== 'file' ? (
                              <MyButton
                                style={{ marginRight: 10 }}
                                type="secondary"
                                content={
                                  <span>
                                    <span>{"Save as Draft"}</span>
                                  </span>
                                }
                                onClick={() => {
                                  // hfinish
                                  setBatchSubmit(true);

                                  //   ? onClose()
                                  //   :
                                  saveTransaction(
                                    {
                                      ...values,
                                    },
                                    true
                                  );
                                }}
                              />) : (<br />)

                            }
                            <MyButton
                              style={{ paddingInline: 40 }}
                              content={
                                currentStepIndex !== 2 && values?.batch_type !== 'file'
                                  ? `Next: ${currentStepIndex === 0
                                    ? `Accounts Selection`
                                    : "Review"
                                  }`
                                  : "Charge Now"
                              }
                              onClick={() => {
                                if (currentStepIndex === 2 || values?.batch_type === 'file') {
                                  if (values?.batch_type !== 'file') {
                                    saveTransaction(values, false);
                                  } else {
                                    uploadFile(values)
                                  }

                                } else {
                                  onStepClick(
                                    values,
                                    handleNext,
                                    setFieldValue,
                                    currentStepIndex
                                  );
                                  // setHFinish(currentStepIndex + 1 === 2);
                                }
                              }}
                              disabled={loading}
                            // disabled={ loading ||
                            //   (!values.batch_name ||
                            //   !values.description ||
                            //   !values.Ledger.name ||
                            //   !values.SubLedger.name ||
                            //   !values.amount ||
                            //   !values.due_date)
                            // }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            );
          }}
        </FormikWizard>
      </div>
    </>
  );
};
export default NewBatchBillinCharge;
